import { FormHelperTextClassKey } from '@material-ui/core/FormHelperText';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

export const THDFormHelperTextStyles: Partial<
  Record<FormHelperTextClassKey, CSSProperties>
> = {
  root: {
    fontSize: '12px',
    fontFamily:
      '"helvetica-neue", Helvetica Neue, Helvetica, Arial, sans-serif',
    '&$error': {
      color: '#AB0000',
    },
  },
  error: {},
  disabled: {},
  marginDense: {},
  focused: {},
  filled: {},
  required: {},
};
